<wr-new-data-table
  [insideCard]="false"
  localStorageIdentifier="building-flat-overview"
  [loadItemsFunction]="loadFlats"
  [getCountFunction]="getFlatCount"
  (lineClick)="navigateToFlat($event)"
  [form]="flatListFilterForm"
  (newClick)="add()"
  [isAdmin]="canCreate()">
  <ng-template dataTableFilter>
    <form *ngIf="flatListFilterForm" [formGroup]="flatListFilterForm" class="filter-form">
      <div *ngIf="buildingId()">
        <label class="label" for="buildingSection">Gebäudeteil</label>
        <wr-building-section-multi-select [buildingId]="buildingId()!" formControlName="buildingSectionIds">
        </wr-building-section-multi-select>
      </div>
      <div>
        <label class="label" for="flatNumber">Nummer</label>
        <input type="number" nbInput id="flatNumber" formControlName="flatNumber" placeholder="Nummer...">
      </div>
      <div>
        <label class="label" for="floor">Etage</label>
        <input type="number" nbInput id="floor" formControlName="floor" placeholder="Etage...">
      </div>
      <div>
        <label class="label" for="doorNumber">Tür</label>
        <input type="text" nbInput id="doorNumber" formControlName="doorNumber" placeholder="Tür...">
      </div>
    </form>
  </ng-template>
  <!-- BUG-11 fix: use !== null check instead of falsy check so 0 displays correctly -->
  <ng-template
    dataColumn
    let-flat
    key="flatNumber"
    display="Nummer">
    <div *ngIf="flat.flatNumber !== null && flat.flatNumber !== undefined">
      {{ flat.flatNumber }}
    </div>
  </ng-template>
  <ng-template
    dataColumn
    let-flat
    key="size"
    [exportDecimals]="2"
    display="Fläche">
    <div *ngIf="flat.size">
      {{ flat.size | number: '1.0-2' }} m²
    </div>
  </ng-template>
  <ng-template
    dataColumn
    let-flat
    key="floor"
    display="Etage">
    <div *ngIf="flat.floor !== null && flat.floor !== undefined">
      {{ flat.floor }}
    </div>
  </ng-template>
  <ng-template
    dataColumn
    let-flat
    key="doorNumber"
    display="Tür">
    <div *ngIf="flat.doorNumber !== null && flat.doorNumber !== undefined">
      {{ flat.doorNumber }}
    </div>
  </ng-template>
  <ng-template
    dataColumn
    let-flat
    key="buildingSection"
    exportKey="buildingSection.sectionText"
    display="Gebäudeteil">
    <div *ngIf="flat.buildingSection">
      <wr-building-section-badge [buildingSection]="flat.buildingSection"></wr-building-section-badge>
    </div>
  </ng-template>
</wr-new-data-table>
